const api = 'https://prodz-api.productions.com';
// const api = 'http://100.81.106.71:9000';
// const api = 'http://localhost:9000';
export const apiEndpoint = (path) => {
  return `${api}${path}`;
};
